import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Academics from '../views/Academics.vue'
import PageNotMade from '../views/PageNotMade.vue'
import PageNotFound from '../views/PageNotFound.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/work',
        name: 'Work',
        component: PageNotMade
    },
    {
        path: '/academics',
        name: 'Academics',
        component: Academics
    },
    {
        path: '/academics',
        name: 'Capstone',
        component: Academics
    },
    {
        path: '/projects',
        name: 'Projects',
        component: PageNotMade
    },
    {
        path: '/art',
        name: 'Art',
        component: PageNotMade
    },
    {
        path: '/personal',
        name: 'Personal',
        component: PageNotMade
    },
    { path: '/:pathMatch(.*)*', component: PageNotFound }
]

const router = createRouter({
    history: createWebHashHistory(),//createWebHistory(process.env.BASE_URL),
    routes
})

export default router